<template>
    <div class="container">
        <div class="content">
            <login v-model="loginModel" @callback="getOrder"></login>
            <paydailog v-model="showpay" :totalPrice="selectPrice"  :paysrc="paysrc" :outTradeNo="out_trade_no" :payType="payType"></paydailog>
            <el-card style="margin:0 auto;min-height:500px;" v-loading="loading">
                <!-- '待付款', '处理中', '已完成', '已退款', '已取消' -->
                <el-menu :default-active="activeIndex" active-text-color="#3A82FF" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="-1">全部</el-menu-item>
                    <el-menu-item index="0">待付款</el-menu-item>
                    <el-menu-item index="3">处理中</el-menu-item>
                    <el-menu-item index="7">已完成</el-menu-item>
                    <el-menu-item index="5">已退款</el-menu-item>
                    <el-menu-item index="2">已取消</el-menu-item>
                </el-menu>

                <el-table
                    :data="lists"
                    style="width: 100%">
                    <el-table-column
                        prop="AliOrderId"
                        label="订单号码"
                        width="300"
                        header-align="center"
                        align="center"
                        :render-header="renderHeader">
                    </el-table-column>
                    <el-table-column
                        prop="car_no"
                        label="车牌号码"
                        min-width="180"
                        header-align="center"
                        align="center"
                        :render-header="renderHeader">
                    </el-table-column>
                    <el-table-column
                        prop="btr_time"
                        label="认罚时间"
                        min-width="180"
                        header-align="center"
                        align="center"
                        :render-header="renderHeader">
                    </el-table-column>
                    <el-table-column
                        prop="CreateTime"
                        label="下单时间"
                        min-width="180"
                        header-align="center"
                        align="center"
                        :render-header="renderHeader">
                    </el-table-column>
                    <el-table-column
                        prop="totalPrice"
                        label="罚单金额"
                        min-width="180"
                        align="center"
                        header-align="center"
                        :render-header="renderHeader">
                    </el-table-column>
                    <el-table-column
                        prop="tag"
                        label="订单状态"
                        min-width="180"
                        header-align="center"
                        align="center"
                        :render-header="renderHeader">
                        <template slot-scope="scope">
                            <div style="flex:1 1 20%;text-align:center" v-if="scope.row.Status == 0">
                                <el-button style="margin-bottom:10px;width:98px" type="primary" @click="bindPay(scope.row,'alipay')">支付宝</el-button>
                                <el-button style="margin-bottom:10px;margin-left:0" type="success" @click="bindPay(scope.row,'wechat_web')">微信支付</el-button>
                                <el-button style="margin-left:0" @click="cancelOrder(scope.row.id)">取消订单</el-button>
                            </div>
                            <div v-else>
                                {{scope.row.tag}}
                            </div>
                        </template>
                    </el-table-column>
                    <div slot="empty" style="text-align:center;margin-top:60px">
                        <img src="../assets/credit3x.png" style="width:150px" />
                        <p style="fomt-size:24px;margin:20px 0;">暂无订单</p>
                    </div>
                </el-table>
            </el-card>
        </div>
        
    </div>
</template>
<script>
import login from './component/Login.vue'
import payDailog from './component/PayDailog.vue'
import icon1 from '../assets/icon1.png'
import icon2 from '../assets/icon2.png'
import icon3 from '../assets/icon3.png'
import icon4 from '../assets/icon4.png'
import icon5 from '../assets/icon5.png'
import icon6 from '../assets/icon6.png'



export default {
    components: {
        'login':login,
        'paydailog': payDailog
    },
    data() {
        return {
            activeName:'-1',
            lists:[],
            loginModel: false,
            loading:false,
            showpay:false,
            selectPrice:0,
            paysrc:'',
            out_trade_no:'',
            payType:'alipay',
            UserTel: window.localStorage.UserTel || '',
            activeIndex: '-1'
        }
    },
    mounted(){
        this.getOrder()
    },
    methods:{
        handleClick(){
            this.getOrder()
        },
        handleSelect(key) {
            this.activeName = key
            this.getOrder()
        },
        getOrder() {
            let self = this;
            let param = {
                status: this.activeName
            }
            if(window.localStorage.UserTel){
                this.$emit('getLogin')
            }
            this.loading = true
            this.$request('v3/violation/order/list', param).then((xhr, res) => {
                if(res.code == 20022) {
                    self.loading = false
                    this.loginModel = true
					return;
				}
                if (res.code > 40000 && res.code < 50000) {
                    self.loading = false
                    this.loginModel = true
                    return;
                }
                if (res.code == 0 && res.data) {
                    let list = res.data && res.data.map((item) => {
                        item.tag = item.Status == 0 ? '待付款' : item.Status == 3 ? '处理中' : item.Status == 7 ? '已完成' : item.Status == 5 ? '已退款' : '已取消'
                        item.btr_time = item.btr_time && item.btr_time.substring(0, 10) || '-'
                        item.totalPrice = ((item.TotalPrice || 0) / 100).toFixed(2)
                        return item
                    })
                    self.lists = list;
                    self.loading = false
                } else {
                    self.lists = [];
                    self.loading = false
                }
            });
        },
        bindPay(item,payType) {
            let self = this
            this.payType = payType
            let params = {
                order_id: item.id,
            }
            if(payType == 'wechat_web') {
                params.pay_method = 'wechat_web'
            }
            this.$request('v3/violation/web/order/repay', params).then((xhr, res) => {
                if(res.code == 20022) {
                    this.loginModel = true
					return;
				}
                if (res.code > 40000 && res.code < 50000) {
                    this.loginModel = true
                    return;
                }
                if (res.code == 0) {
                    self.paysrc = payType === 'wechat_web' ? res.data.CodeImg : res.data.qr_code_img
                    self.out_trade_no = res.data.out_trade_no
                    self.showpay = true
                    self.selectPrice = Math.round((item.TotalPrice || 0))
                } else {
                    this.$message.error(res.msg);
                } 
            });
        },
        cancelOrder(id) {
            let self = this
            let param = {
                order_id: id
            }
            this.$confirm('此操作将取消订单 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$request('v3/violation/order/cancel', param).then((xhr, res) => {
                        if (res.code == 0) {
                            self.getOrder(0);
                            self.getOrderStatic();
                            this.$message({
                                type: 'success',
                                message: '取消成功!'
                            });
                        }else{
                            this.$message.error(res.msg)
                        }
                    });
                    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });          
                });
            
        },


        tableRowClassName({rowIndex}) { 
            if (rowIndex === 1) { 
                return 'warning-row'; 
            } 
            else if (rowIndex === 3) { 
                return 'success-row'; 
            } 
            return ''; 
        }, 
        // render 事件 
        renderHeader (h,{column}) { // h即为cerateElement的简写，具体可看vue官方文档 
            let src = ''
            switch (column.label) {
                case '订单号码': src = icon1
                break;
                case '车牌号码': src = icon2
                break;
                case '认罚时间': src = icon3
                break;
                case '下单时间': src = icon4
                break;
                case '罚单金额': src = icon5
                break;
                case '订单状态': src = icon6
                break;

                default:
                    break;
            }
            return h( 
                'div', 
                {
                    style: "display: flex;align-items: center;justify-content: center;"
                },
                [ 
                    h(
                        'img', 
                        { 
                            class: "icon-class", 
                            attrs:{
                                src:src                       
                            } 
                        }
                    ) ,
                    h('span', column.label), 
                    
                ]
            ); 
        }

    }
}
</script>
<style scoped>
.ordeList {
    margin-bottom:20px
}
.ordeList .el-form-item{
    margin-bottom:0px
}
.redColor {
    color: #F75A00 
}
.panel{
    font-size: 30px;
    padding: 20px 50px;
}

</style>
<style>
.el-tabs__item {
    font-size: 16px;
    color: #002257;
}
</style>



